// extracted by mini-css-extract-plugin
module.exports = {"fluidHeader":"header_fluidHeader__1E7bf","computerVisible":"header_computerVisible__ZgS8Q","flexGrow":"header_flexGrow__3HfqQ"};